import {
  legacy_createStore as createStore,
  applyMiddleware,
  combineReducers,
} from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import storage from "./sync_storage";
import userReducer from "./UserStore/reducer";
import AdminReducer from "./AdminStore/reducer";
import centerOnboardReducer from "./CenterOnboardStore/reducer";
import clientReducer from "./ClientStore/reducer";

// Combine all reducers
const rootReducer = combineReducers({
  userReducer,
  AdminReducer,
  centerOnboardReducer,
  clientReducer,
});

// Redux Persist config
const persistConfig = {
  key: "root",
  whitelist: [
    "userReducer",
    "AdminReducer",
    "centerOnboardReducer",
    "clientReducer",
  ],
  storage,
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure middleware
const middleware = [thunk];

// Create store with proper devtools setup
const store = createStore(
  persistedReducer,
  process.env.NODE_ENV === "development"
    ? composeWithDevTools(applyMiddleware(...middleware))
    : applyMiddleware(...middleware)
);

// Create persistor
const persistor = persistStore(store);

export { store, persistor };
